export default function WindowLocation($window) {
  'ngInject';

  // In JSDOM 21+ window.location is essentially unmockable so this wrapper
  // allows us to mock this factory entirely in unit tests
  return $window.location;
}
